import BaseModelService from '../../base/base_model_service';
import * as RegulationConst from '../regulation/regulation_const';
import {SYSTEM_EVENTS} from '../../events/events';
import Event from '../../utils/event';
import ServiceFactory from '../service_factory';

class MenuModel extends BaseModelService {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'MenuModel';
    /**
     * @property
     * @type {*[]}
     * @private
     */
    _menuDefault = [
        {
            id: 'gaming_history',
            title: 'menu_gaming_history',
            translation: '',
            analyticEvent: () => { window.CGP.sendAnalytics({category: 'Client_UserMenu', action: 'GamingHistory'});},
            action: () => { window.CGP.openHistoryLink()},
            link: 'window.CGP.menuActionExecute(\'gaming_history\')',
            display: (isAuthorize) => {
                return this.setVisible(0, isAuthorize, true);
            },
            level: 1
        },
        {
            id: 'session_history',
            title: 'menu_gaming_session_history',
            translation: '',
            analyticEvent: () => { window.CGP.sendAnalytics({category: 'Client_UserMenu', action: 'GamingSessionHistory'});},
            action: () => { window.CGP.openGameSessionHistoryLink()},
            link: 'window.CGP.menuActionExecute(\'session_history\')',
            display: (isAuthorize) => {
                let regulations = [RegulationConst.REGULATION_CODE_TYPES.SPAIN];
                let nCode = Number(ServiceFactory.create().regulationService().getRegulationCode());
                let bVal = regulations.find(r => r === nCode) === nCode;
                return this.setVisible(1, isAuthorize, bVal);
            },
            level: 1
        },
        {
            title: 'menu_reminders',
            translation: '',
            analyticEvent: () => { window.CGP.sendAnalytics({category: 'Client_UserMenu', action: 'GameReminders'});},
            action: () =>  {window.CGP.openOptions('ReminderSettings');},
            link: 'window.CGP.menuActionExecute(\'reminder_button\')',
            id: 'reminder_button',
            display: (isAuthorize) => {
                let regulations = [RegulationConst.REGULATION_CODE_TYPES.UK, RegulationConst.REGULATION_CODE_TYPES.MALTA];
                let nCode = Number(ServiceFactory.create().regulationService().getRegulationCode());
                let bVal = regulations.find(r => r === nCode) === nCode;

                return this.setVisible(2, isAuthorize, bVal);
            },
            level: 1
        },
        {
            title: 'menu_touch_id',
            translation: '',
            analyticEvent: () => { window.CGP.sendAnalytics({category: 'Client_UserMenu', action: 'TouchId'});},
            action: () => {
                Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {category: 'Client_UserMenu', action: 'TouchID'});
                window.CGP.openOptions('TouchId', '2');},
            link: 'window.CGP.menuActionExecute(\'touch_id_button\')',
            id: 'touch_id_button',
            display: (isAuthorize) => {
                const hybridService = ServiceFactory.create().hybridService();
                return hybridService.isDeviceTouchEnable().then(bVal => {
                    const asyncTasks = [];

                    bVal && asyncTasks.push(hybridService.getTouchIDFeaturer().getTokenAndCheckEnable()
                            .then(isTokenAndCheckEnable => {
                                if(!!isTokenAndCheckEnable){
                                    this.setVal(3, 'sideText', 'On');
                                    this.setVal(3, 'sideTextClass', 'cgp-theme-property-color-main');
                                }else{
                                    this.setVal(3, 'sideText', 'Off');
                                    this.setVal(3, 'sideTextClass', 'cgp-theme-property-color-base02');
                                }
                            }));

                    this.setVisible(3, isAuthorize, bVal);

                    return Promise.all(asyncTasks);
                });
            },
            level: 1
        },
        {
            title: 'menu_cashier_history',
            translation: '',
            analyticEvent: () => { window.CGP.sendAnalytics({category: 'Client_UserMenu', action: 'menu_cashier_history'});},
            action: () => { window.CGP.openExternalLink({source: 'cashier', options: {sessionType: 2} })},
            link: 'window.CGP.menuActionExecute(\'cashier_history_tab\')',
                id: 'cashier_history_tab',
            display: (isAuthorize) => {
            let regulations = [
                RegulationConst.REGULATION_CODE_TYPES.ITALY,
                RegulationConst.REGULATION_CODE_TYPES.DK,
                RegulationConst.REGULATION_CODE_TYPES.SPAIN,
                RegulationConst.REGULATION_CODE_TYPES.PORTUGAL
            ];

            let nCode = Number(ServiceFactory.create().regulationService().getRegulationCode());
            let bVal = regulations.find(r => r === nCode) === nCode;
            bVal = bVal && !ServiceFactory.create().integrationService().isMiniOrbit();

            return this.setVisible(4, isAuthorize, bVal);
            },
            level: 1
        },
        {
            title: 'menu_inactivity_timeout_settings',
            translation: '',
            analyticEvent: () => { window.CGP.sendAnalytics({category: 'Client_UserMenu', action: 'inactivity_timeout_settings'}); },
            action: () =>  { window.CGP.openOptions('InactivityTimeoutSettings'); },
            link: 'window.CGP.menuActionExecute(\'inactivity_timeout_settings_button\')',
            id: 'inactivity_timeout_settings_button',
            display: (isAuthorize) => {
            let regulations = [RegulationConst.REGULATION_CODE_TYPES.ITALY];
            let nCode = Number(ServiceFactory.create().regulationService().getRegulationCode());
            let bVal = regulations.find(r => r === nCode) === nCode;
            return this.setVisible(5, isAuthorize, bVal);
        },
            level: 1
        },
        {
            title: 'menu_cashier_docs',
            translation: '',
            analyticEvent: () => { window.CGP.sendAnalytics({category: 'Client_UserMenu', action: 'cashier_docs_tab'});},
            action: () => { window.CGP.openExternalLink({source: 'cashier', options: {sessionType: 20} })},
            link: 'window.CGP.menuActionExecute(\'cashier_docs_tab\')',
            id: 'cashier_docs_tab',
            display: (isAuthorize) => {
            let regulations = [RegulationConst.REGULATION_CODE_TYPES.ITALY];
            let hideInMiniOrbitRegulations = [RegulationConst.REGULATION_CODE_TYPES.ITALY];
            let nCode = Number(ServiceFactory.create().regulationService().getRegulationCode());
            let bVal = regulations.find(r => r === nCode) === nCode;
            if(ServiceFactory.create().integrationService().isMiniOrbit()){
                bVal = bVal && hideInMiniOrbitRegulations.find(r => r === nCode) !== nCode;
            }
            return this.setVisible(6, isAuthorize, bVal);
        },
            level: 1
        },
        {
            id: 'about',
            title: 'menu_about',
            translation: '',
            action: () => { window.CGP.openOptions('About'); },
            link: 'window.CGP.menuActionExecute(\'about\')',
            display: (isAuthorize) => {
                return this.setVisible(7, isAuthorize, true);
            },
            level: 1
        },
        {
            title: 'menu_logout',
            translation: '',
            analyticEvent: () => { window.CGP.sendAnalytics({category: 'Client_UserMenu', action: 'Logout'});},
            action: () => { window.CGP.logout()},
            link: 'window.CGP.menuActionExecute(\'logout_button\')',
            id: 'logout_button',
            display: (isAuthorize) => {
                return this.setVisible(8, isAuthorize, true);
            },
            level: 1
        },
        {
            title: 'menu_hybrid_info',
            translation: '',
            analyticEvent: () => { window.CGP.sendAnalytics({category: 'Client_UserMenu', action: 'hybrid_info'}); },
            action: () =>  { window.CGP.showInfo(ServiceFactory.create().hybridService().getInfoForDisplay()); },
            link: 'window.CGP.menuActionExecute(\'hybrid_info_button\')',
            id: 'hybrid_info_button',
            display: (isAuthorize) => {
                let bIsDebugMode = ServiceFactory.create().hybridService().isDebugMode();
                return this.setVisible(9, isAuthorize, bIsDebugMode);
            },
            level: 1
        }
    ];
    /**
     *
     */
    init() {}

    setVal(id, key, val) {
        this._menuDefault[id][key] = val;
    }
    
    setVisible(id, isAuthorize, visible) {
        const show = this._menuDefault[id].level === isAuthorize;
        this.setVal(id, 'visible', show && visible);
    }
    /**
     *
     * @returns {*[]}
     * @public
     */
    getMenuStructure() {
        return this._menuDefault;
    }
}

export default MenuModel;